import { type JSX } from 'react/jsx-runtime';

import { createRender } from './types';

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(() => <button>{`Hello world!`}</button>);

export default render;
